export const isMarketOpen = () => {
  const ny = new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));
  const d = ny.getDay(), t = ny.getHours() * 60 + ny.getMinutes();
  return d > 0 && d < 6 && t >= 570 && t < 960;
};

export const getNextMarketOpen = () => {
  const ny = new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));
  const d  = ny.getDay();
  const t  = ny.getHours() * 60 + ny.getMinutes();
  const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  let add = 0;
  if      (d === 0)    add = 1;
  else if (d === 6)    add = 2;
  else if (t >= 960) { add = d === 5 ? 3 : 1; }
  const next = new Date(ny);
  next.setDate(ny.getDate() + add);
  if      (add === 0) return "today at 9:30 AM ET";
  else if (add === 1) return "tomorrow at 9:30 AM ET";
  else                return `${DAYS[next.getDay()]} at 9:30 AM ET`;
};
